
//export const getURL = 'https://property.vidisky.ai:2053' // old production
export const getURL = 'https://property-api.vidisky.ai' // new production
//export const getURL = 'http://192.168.0.115:9047' // local
